<div class="closing-x-wrap">
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>
<h1 mat-dialog-title id="signature-title">{{ title }}</h1>

<div mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field style="width: 100%" appearance="fill" class="col">
            <mat-label>{{ label }}</mat-label>
            <input class="form-control" type="text" matInput formControlName="name" autocomplete="off" maxlength="85" />
            <mat-error>{{ label }} is required</mat-error>
        </mat-form-field>
        <div *ngIf="data.includeIsDealerOnlyCheckbox">
            <mat-checkbox (click)="toggleIsChecked()"  [checked]="data.isDealerOnly === true && true"> This document will only be seen by the Dealer
            </mat-checkbox>
           
        </div>
    </form>
    
</div>

<div class="form-footer" mat-dialog-actions>
    <button mat-button class="primary" (click)="submit()">Update</button>
</div>
